import {createElement} from 'react';

import classNames from 'classnames';

import type {ComponentPropsWithoutRef, ElementType, ReactElement, ReactNode} from 'react';

export type ItemProps<T extends ElementType = 'div'> = {
    as?: T,
    children?: ReactNode,
    /**
     * hidden style on item
     * */
    hidden?: boolean,
    /**
     * Style grow
     * */
    grow?: number,
    /**
     * Style shrink
     * */
    shrink?: number,
    /**
     * Style order
     * */
    order?: number,
    /**
     * Style basis
     * */
    basis?: 'auto' | string,
    /**
     * Style align-self
     * */
    align?: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch' | 'start' | 'end' | 'self-start' | 'self-end' | 'normal',
} & ComponentPropsWithoutRef<T>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Item<T extends ElementType = 'div'>(props: ItemProps<T>): ReactElement<any> {
    const {
        as = 'div',
        hidden = false,
        grow,
        shrink,
        order,
        basis,
        align,
        ...otherProps
    } = props;

    const itemClass = classNames('group__i', otherProps.className, {
        group__i_hid: hidden,
    });

    const itemStyle = {
        '--gr__i-g': grow,
        '--gr__i-s': shrink,
        '--gr__i-or': order,
        '--gr__i-bs': basis,
        '--gr__i-as': align,
        ...otherProps.style,
    };

    return createElement(as, {
        ...otherProps,
        style: itemStyle,
        className: itemClass,
    }, props.children);
}
